import type {RouteMap} from '../types/routes.js';
import {getRule} from '../utils/routes.js';
import {FlywheelComponent} from './component.js';
import {FlywheelRouter} from './router.js';

export class App {
  name: string;
  routes: RouteMap;
  pathname: string;

  constructor({name, routes}: {name: string; routes: RouteMap}) {
    this.name = name;
    this.routes = routes;
    this.pathname = window.location.pathname;
  }

  private matchesPathname(pathname: string) {
    return Object.values(this.routes).filter(route => {
      return (
        route.paths.includes('*') ||
        route.paths.includes(pathname) ||
        getRule(pathname, route.paths)
      );
    });
  }

  async loadComponentsForPath(pathname: string): Promise<void> {
    const promises: Promise<unknown>[] = [];

    this.matchesPathname(pathname).forEach(({components, paths}) => {
      for (const key in components) {
        const loader = components[key];

        // Add static paths
        FlywheelComponent.paths = paths;

        // Adds router
        FlywheelComponent.router ??= new FlywheelRouter(this.routes);

        promises.push(loader());
      }
    });

    return Promise.all(promises).then(() => undefined);
  }

  init() {
    this.loadComponentsForPath(this.pathname);
  }
}
